import React, { Component } from "react";
import Input from "../inputs/input";
import Select from "../selects/select";
import Password from "../inputs/password";
import CpfUtils from "../../shared/utils/CpfUtils";
import RgUtils from "../../shared/utils/RgUtils";
import PhoneUtils from "../../shared/utils/PhoneUtils";
import EmailUtils from "../../shared/utils/EmailUtils";

class FormularioUsuario extends Component {
  constructor(props) {
    super(props);

    this.telefoneRef = React.createRef();
    this.celularRef = React.createRef();
    this.firstInputRef = React.createRef();
  }

  focusFirstField = () => {
    if (this.firstInputRef.current) {
      const input = this.firstInputRef.current.querySelector("input");
      if (input) {
        input.focus();
      }
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    let cleaned = value;

    if (name === "cpf") {
      cleaned = CpfUtils.cleanCpf(value);
    } else if (name === "rg") {
      cleaned = RgUtils.cleanRg(value);
    } else if (name === "email" || name === "email1") {
      cleaned = EmailUtils.formatEmail(value);
    } else if (["dddTelefone", "dddCelular", "telephone", "cellphone"].includes(name)) {
      cleaned = PhoneUtils.cleanPhone(value);
    }

    if (this.props.onChange) {
      this.props.onChange(name, cleaned);
    }

    if (name === "dddTelefone" && cleaned.length === 2) {
      setTimeout(() => {
        if (this.telefoneRef.current) {
          const input = this.telefoneRef.current.querySelector("input");
          if (input) input.focus();
        }
      }, 50);
    } else if (name === "dddCelular" && cleaned.length === 2) {
      setTimeout(() => {
        if (this.celularRef.current) {
          const input = this.celularRef.current.querySelector("input");
          if (input) input.focus();
        }
      }, 50);
    }
  };

  handleFocus = (e, fieldName) => {
    const { name } = e.target;

    if (this.isReadOnly(name)) {
      return;
    }

    const currentValue = this.props.values[name] || '';

    if (name === 'cpf' && currentValue) {
      const formatted = CpfUtils.formatCpf(currentValue);
      if (formatted !== currentValue && this.props.onChange) {
        this.props.onChange(name, formatted);
      }
    } else if (name === 'rg' && currentValue) {
      const formatted = RgUtils.formatRg(currentValue);
      if (formatted !== currentValue && this.props.onChange) {
        this.props.onChange(name, formatted);
      }
    } else if ((name === 'telephone' || name === 'cellphone') && currentValue) {
      const formatted = PhoneUtils.formatPhone(currentValue);
      if (formatted !== currentValue && formatted !== currentValue.replace(/[^0-9]/g, '') && this.props.onChange) {
        this.props.onChange(name, formatted);
      }
    }

    if (e.target && e.target.classList) {
      e.target.classList.remove("has-error");
    }
  };

  isReadOnly = (fieldName) => {
    return this.props.readOnly === true || (this.props.readOnlyFields && this.props.readOnlyFields.includes(fieldName));
  };

  render() {
    const {
      values = {},
      errors = {},
      showLabels = true,
      showPasswordFields = true,
      showTermsFields = true,
      showEmailConfirmation = true,
      showPerfil = true,
      papeis = [],
      onlyS9 = false
    } = this.props;

    const readOnlyFields = this.props.readOnlyFields || [];

    const papelAtual = values.papel;
    const papeisExibidos = this.isReadOnly("papel") && papelAtual && !papeis.some(item => item.value === papelAtual)
      ? [...papeis, { label: papelAtual, value: papelAtual }]
      : papeis;

    return (
      <div>
        {showLabels && (
          <>
            <h2 className="signup-right__next-account--title">Cadastro do Usuário</h2>
            <p className="signup-right__next-account--warning">* Campos obrigatórios</p>
          </>
        )}

        <div className="row">
          <div className="col-12 col-md-6" ref={this.firstInputRef}>
            <Input
              name="nome"
              id="name"
              width="100%"
              type="text"
              label="Nome*"
              value={values.nome || ""}
              required={!this.isReadOnly("nome")}
              onChange={this.handleChange}
              readOnly={this.isReadOnly("nome")}
            />
            <span className="field-error-message" style={{ visibility: errors.nome ? "visible" : "hidden" }}>
              {errors.nome || "Campo obrigatório"}
            </span>
          </div>
          <div className="col-12 col-md-6">
            <Input
              name="surname"
              id="surname"
              width="100%"
              type="text"
              label="Sobrenome*"
              value={values.surname || ""}
              required={!this.isReadOnly("surname")}
              onChange={this.handleChange}
              readOnly={this.isReadOnly("surname")}
            />
            <span className="field-error-message" style={{ visibility: errors.surname ? "visible" : "hidden" }}>
              {errors.surname || "Campo obrigatório"}
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <Input
              name="email"
              id="email"
              width="100%"
              type="email"
              label="E-mail*"
              value={values.email || ""}
              required={!this.isReadOnly("email")}
              onChange={this.handleChange}
              onFocus={e => this.handleFocus(e, 'email')}
              readOnly={this.isReadOnly("email")}
            />
            <span className="field-error-message" style={{ visibility: errors.email ? "visible" : "hidden" }}>
              {errors.email || "Campo obrigatório"}
            </span>
          </div>
          {showEmailConfirmation && (
            <div className="col-12 col-md-6">
              <Input
                name="email1"
                id="email1"
                width="100%"
                type="email"
                label="Confirmar e-mail*"
                value={values.email1 || ""}
                required={!this.isReadOnly("email1")}
                onChange={this.handleChange}
                onFocus={e => this.handleFocus(e, 'email1')}
                readOnly={this.isReadOnly("email1")}
              />
              <span className="field-error-message" style={{ visibility: errors.email1 || errors.emailInvalid ? "visible" : "hidden" }}>
                {errors.emailInvalid ? "Os e-mails não conferem." : (errors.email1 || "Campo obrigatório")}
              </span>
            </div>
          )}
          {showEmailConfirmation && (
            <small>Este e-mail fará sua autenticação no Essilor Conecta. Você deve informar um email válido e que apenas você acesse.</small>
          )}
        </div>

        <div className="row">
          {showPerfil && (
            <div className="col-12 col-md-6">
              <Select
                name="papel"
                width="100%"
                label="Perfil*"
                itens={papeisExibidos}
                value={values.papel || ""}
                onChange={this.handleChange}
                disabled={this.isReadOnly("papel")}
                required={!this.isReadOnly("papel")}
              />
              <span className="field-error-message" style={{ visibility: errors.papel ? "visible" : "hidden" }}>
                {errors.papel || "Campo obrigatório"}
              </span>
            </div>
          )}

          <div className={showPerfil ? "col-12 col-md-6" : "col-12"}>
            <Input
              name="datanasc"
              id="datanasc"
              width="100%"
              type="text"
              label="Data de nascimento*"
              value={values.datanasc || ""}
              required={!this.isReadOnly("datanasc")}
              mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
              onChange={this.handleChange}
              readOnly={this.isReadOnly("datanasc")}
            />
            <span className="field-error-message" style={{ visibility: errors.datanasc ? "visible" : "hidden" }}>
              {errors.datanasc || "Campo obrigatório"}
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-6">
            <Input
              name="cpf"
              id="cpf"
              type="text"
              width="100%"
              label={onlyS9 ? "CPF" : "CPF*"}
              value={values.cpf || ""}
              required={!onlyS9 && !this.isReadOnly("cpf")}
              mask={[/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/]}
              onChange={this.handleChange}
              onFocus={e => this.handleFocus(e, 'cpf')}
              readOnly={this.isReadOnly("cpf")}
            />
            <span className="field-error-message" style={{ visibility: errors.cpf ? "visible" : "hidden" }}>
              {errors.cpf || "Campo obrigatório"}
            </span>
          </div>
          <div className="col-12 col-md-6">
            <Input
              name="rg"
              id="rg"
              type="text"
              width="100%"
              label={onlyS9 ? "RG" : "RG*"}
              value={values.rg || ""}
              required={!onlyS9 && !this.isReadOnly("rg")}
              mask={[/\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/]}
              onChange={this.handleChange}
              onFocus={e => this.handleFocus(e, 'rg')}
              readOnly={this.isReadOnly("rg")}
            />
            <span className="field-error-message" style={{ visibility: errors.rg ? "visible" : "hidden" }}>
              {errors.rg || "Campo obrigatório"}
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-2">
            <Input
              name="dddTelefone"
              id="dddTelefone"
              label="DDD"
              type="text"
              mask={[/\d/, /\d/]}
              width="100%"
              value={values.dddTelefone || ""}
              onChange={this.handleChange}
              onFocus={e => this.handleFocus(e, 'dddTelefone')}
              maxLength={2}
              readOnly={this.isReadOnly("dddTelefone")}
            />
            <span className="field-error-message" style={{ visibility: errors.dddTelefone ? "visible" : "hidden" }}>
              {errors.dddTelefone || ""}
            </span>
          </div>
          <div className="col-12 col-md-4" ref={this.telefoneRef}>
            <Input
              name="telephone"
              id="telephone"
              width="100%"
              type="text"
              label="Telefone"
              value={values.telephone || ""}
              mask={[/\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
              onChange={this.handleChange}
              onFocus={e => this.handleFocus(e, 'telephone')}
              maxLength={9}
              readOnly={this.isReadOnly("telephone")}
            />
            <span className="field-error-message" style={{ visibility: errors.telephone ? "visible" : "hidden" }}>
              {errors.telephone || ""}
            </span>
          </div>
          <div className="col-12 col-md-2">
            <Input
              name="dddCelular"
              id="dddCelular"
              label="DDD*"
              type="text"
              mask={[/\d/, /\d/]}
              width="100%"
              value={values.dddCelular || ""}
              onChange={this.handleChange}
              onFocus={e => this.handleFocus(e, 'dddCelular')}
              maxLength={2}
              required={!this.isReadOnly("dddCelular")}
              readOnly={this.isReadOnly("dddCelular")}
            />
            <span className="field-error-message" style={{ visibility: errors.dddCelular ? "visible" : "hidden" }}>
              {errors.dddCelular || "Campo obrigatório"}
            </span>
          </div>
          <div className="col-12 col-md-4" ref={this.celularRef}>
            <Input
              name="cellphone"
              id="cellphone-number"
              width="100%"
              type="text"
              label="Celular*"
              value={values.cellphone || ""}
              required={!this.isReadOnly("cellphone")}
              mask={[/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
              onChange={this.handleChange}
              onFocus={e => this.handleFocus(e, 'cellphone')}
              maxLength={10}
              readOnly={this.isReadOnly("cellphone")}
            />
            <span className="field-error-message" style={{ visibility: errors.cellphone ? "visible" : "hidden" }}>
              {errors.cellphone || "Campo obrigatório"}
            </span>
          </div>
        </div>

        {showPasswordFields && (
          <div className="row">
            <div className="col-12 col-md-6">
              <Password
                name="password"
                id="password"
                width="100%"
                label="Senha*"
                value={values.password || ""}
                required={!this.isReadOnly("password")}
                onChange={this.handleChange}
                readOnly={this.isReadOnly("password")}
              />
              <span className="field-error-message" style={{ visibility: errors.password ? "visible" : "hidden" }}>
                {errors.password || "Campo obrigatório"}
              </span>
            </div>
            <div className="col-12 col-md-6">
              <Password
                name="confirmPassword"
                id="confirmPassword"
                label="Confirmação de Senha*"
                value={values.confirmPassword || ""}
                width="100%"
                required={!this.isReadOnly("confirmPassword")}
                onChange={this.handleChange}
                readOnly={this.isReadOnly("confirmPassword")}
              />
              <span className="field-error-message" style={{ visibility: errors.confirmPassword || errors.senhasNaoConferem ? "visible" : "hidden" }}>
                {errors.senhasNaoConferem ? "As senhas não conferem." : (errors.confirmPassword || "Campo obrigatório")}
              </span>
            </div>
            {this.props.passwordErrors && values.password && this.props.passwordInvalid && (
              <div className="col-12" style={{ minHeight: "20px" }}>
                <p className="newPassword-text">
                  <ul className="ul-dot">
                    <li className="p-check-new-password" style={{ color: this.props.passwordErrors.hasPercent ? "#d33" : "inherit" }}>
                      A senha não pode conter o caractere especial %
                    </li>
                    <li className="p-check-new-password" style={{ color: this.props.passwordErrors.minLength ? "#d33" : "inherit" }}>
                      A senha deve ter um mínimo de 5 caracteres
                    </li>
                    <li className="p-check-new-password" style={{ color: this.props.passwordErrors.hasNumber ? "#d33" : "inherit" }}>
                      A senha deve ter no mínimo 1 caractere numérico
                    </li>
                    <li className="p-check-new-password" style={{ color: this.props.passwordErrors.hasWhitespace ? "#d33" : "inherit" }}>
                      A senha não pode conter espaços em branco
                    </li>
                  </ul>
                </p>
              </div>
            )}
          </div>
        )}

        {showTermsFields && (
          <div className="signup-right__next-account--checkbox">
            <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "12px" }}>
              <input
                name="terms"
                id="terms"
                type="checkbox"
                checked={values.terms || false}
                required={!this.isReadOnly("terms")}
                onChange={this.props.onCheckboxChange || this.handleChange}
                disabled={this.isReadOnly("terms")}
                style={{ marginRight: "10px", marginTop: "4px", minWidth: "16px" }}
              />
              <label htmlFor="terms" style={{ cursor: "pointer" }}>Aceito os Termos e Condições de Uso e a Política de Privacidade</label>
            </div>

            <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "12px" }}>
              <input
                name="newsletter"
                id="newsletter"
                type="checkbox"
                checked={values.newsletter || false}
                onChange={this.props.onCheckboxChange || this.handleChange}
                disabled={this.isReadOnly("newsletter")}
                style={{ marginRight: "10px", marginTop: "4px", minWidth: "16px" }}
              />
              <label htmlFor="newsletter" style={{ cursor: "pointer" }}>Aceito receber comunicações do grupo Essilor</label>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default FormularioUsuario;
